// shell/components/table/columns/title-column.ts

import { TitleColumnType } from '../types';
import { TextColumnRenderer } from './text-column';
import { CellRenderContext } from './column-base';

export class TitleColumnRenderer<T = unknown> extends TextColumnRenderer<T> {
    constructor(config: TitleColumnType<T>) {
        super({ kind: 'text', converter: config.converter });
    }

    getGridCellClass(): string {
        return 'cs-column-title';
    }

    getTableCellClass(): string {
        return 'cs-column-title';
    }

    // Titles never shade
    protected shouldShadeInGrid(): boolean {
        return false;
    }

    protected shouldShadeInTable(): boolean {
        return false;
    }

    protected buildTextElement(ctx: CellRenderContext<T>): HTMLSpanElement {
        const span = document.createElement('span');
        span.className = 'cs-column-title__content';
        span.textContent = this.formatValue(ctx.value, this.config.converter, ctx.item);
        return span;
    }
}
